import React, { useState } from 'react';
import Editor from '@monaco-editor/react';
import CsvPreview from './CsvPreview';

const MonacoCsvEditor = ({ value, onChange, disabled }) => {
  const [errors, setErrors] = useState([]);

  const validateCsv = (value) => {
    try {
      const lines = value.trim().split('\n');
      if (lines.length < 2) {
        return { isValid: false, errors: ['ヘッダー行と少なくとも1行のデータが必要です'] };
      }
      
      const headers = lines[0].split(',');
      if (headers.some(h => !h.trim())) {
        return { isValid: false, errors: ['空のヘッダーは許可されていません'] };
      }

      for (let i = 1; i < lines.length; i++) {
        const values = lines[i].split(',');
        if (values.length !== headers.length) {
          return { isValid: false, errors: [`${i + 1}行目: カラム数がヘッダーと一致しません`] };
        }
      }

      return { isValid: true, errors: [] };
    } catch (error) {
      return { isValid: false, errors: [error.message] };
    }
  };

  const handleEditorChange = (newValue) => {
    const validation = validateCsv(newValue);
    setErrors(validation.errors);
    onChange(newValue);
  };

  const formatCsv = () => {
    try {
      const lines = value.trim().split('\n');
      const formattedLines = lines.map(line => 
        line.split(',')
          .map(cell => cell.trim())
          .join(', ')
      );
      const formattedValue = formattedLines.join('\n');
      onChange(formattedValue);
    } catch (error) {
      setErrors([error.message]);
    }
  };

  return (
    <div>
      <div style={{ marginBottom: '10px' }}>
        <button 
          onClick={formatCsv}
          style={{
            padding: '8px 16px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
          disabled={disabled}
        >
          フォーマット
        </button>
      </div>
      <Editor
        height="400px"
        defaultLanguage="plaintext"
        value={value}
        onChange={handleEditorChange}
        options={{
          minimap: { enabled: false },
          lineNumbers: 'on',
          scrollBeyondLastLine: false,
          wordWrap: 'on'
        }}
        disabled={disabled}
      />
      {errors.length > 0 && (
        <ul style={{ 
          color: 'red', 
          marginTop: '10px',
          paddingLeft: '20px'
        }}>
          {errors.map((error, index) => (
            <li key={index}>{error}</li>
          ))}
        </ul>
      )}
      <div style={{ marginTop: '20px' }}>
        <CsvPreview value={value} disabled={disabled} />
      </div>
    </div>
  );
};

export default MonacoCsvEditor;
